import { alpha } from "@mui/material/styles";

const DARK_GREY = {
  0: "#000000",
  100: "#161C24",
  200: "#212B36",
  300: "#454F5B",
  400: "#637381",
  500: "#919EAB",
  600: "#C4CDD5",
  700: "#DFE3E8",
  800: "#F4F6F8",
  900: "#FFFFFF",
};

const palettedark = {
  common: { black: "#fff", white: "#000" },
  primary: {
    lighter: "#F2E4C6",
    light: "#C49E5D",
    main: "#d6b87c",
    dark: "#8A6E3D",
    darker: "#4A3B23",
    custom: "#4A3B23",
    contrastText: "#000",
    goldtag: "#d6b87c",
  },
  gold: {
    main: "#A2884C",
  },
  silver: {
    main: "#878685",
  },

  platin: {
    main: "#ADADAD",
  },

  shadow: {
    main: "#b7b7b791",
  },

  svgBg: {
    main: "#38383838",
  },

  secondary: {
    lighter: "#84A9FF",
    light: "#3366FF",
    main: "#1939B7",
    dark: "#091A7A",
    darker: "#04297A",
    contrastText: "#fff",
  },
  info: {
    lighter: "#74CAFF",
    light: "#1890FF",
    main: "#0C53B7",
    dark: "#04297A",
    darker: "#04297A",
    contrastText: "#fff",
  },
  success: {
    lighter: "#AAF27F",
    light: "#54D62C",
    main: "#229A16",
    dark: "#08660D",
    darker: "#08660D",
    contrastText: DARK_GREY[800],
  },
  warning: {
    lighter: "#FFE16A",
    light: "#FFC107",
    main: "#B78103",
    dark: "#7A4F01",
    darker: "#36241C",
    custom: "#36241C",
    contrastText: DARK_GREY[800],
  },
  error: {
    lighter: "#FFA48D",
    light: "#FF4842",
    main: "#B72136",
    dark: "#7A0C2E",
    darker: "#7A0C2E",
    contrastText: "#fff",
  },
  paper: {
    goldPaper: "#4c453a",
    silverPaper: "#585858",
    platinPaper: "#304142",
  },
  paperText: {
    gold: "#D6B87C",
    silver: "#B5B5B6",
    platin: "#81d9dd",
  },
  grey: DARK_GREY,
  divider: alpha(DARK_GREY[500], 0.24),
  text: {
    primary: DARK_GREY[900],
    secondary: DARK_GREY[800],
    disabled: DARK_GREY[700],
    navsec: DARK_GREY[800],
  },
  background: {
    paper: "#242424",
    default: "#383838",
    neutral: "#282828",
    card: "#242424",
    price: "#383838",
  },
  action: {
    active: DARK_GREY[300],
    hover: alpha(DARK_GREY[500], 0.08),
    selected: alpha(DARK_GREY[500], 0.16),
    disabled: alpha(DARK_GREY[500], 0.8),
    disabledBackground: alpha(DARK_GREY[500], 0.24),
    focus: alpha(DARK_GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
  nav: "#242424",
  navText: "#ffffff",
  table: "#272727",
};

export default palettedark;
